import React from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../../firebase/config';

function PrivateRoute({ children }) {
  // Check if user is logged in
  const isAuthenticated = auth.currentUser;
  
  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // If authenticated, render the protected component
  return children;
}

export default PrivateRoute;
